import React from "react";
import { getInitials } from "../requests/utilities/helpers";
import { getCardColor2 } from "../../../helpers/helpers";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import FiberPinIcon from "@mui/icons-material/FiberPin";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";
import UserProfileAttributesTab from "./UserProfileAttributesTab";
import EmployeeProfileCertificationsTab from "../requests/manager/employees/EmployeeProfileCertificationsTab";
import EmployeeProfileTrainingTab from "../requests/manager/employees/EmployeeProfileTrainingTab";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import EmployeeProfileStatisticsTab from "../requests/manager/employees/EmployeeProfileStatisticsTab";
import Drawer from "@mui/material/Drawer";
import DrawerHeader from "../requests/shared/helpers/DrawerHeader";
import DrawerFooterContainerLarge from "../requests/shared/helpers/DrawerFooterContainerLarge";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import AddIcon from "@mui/icons-material/Add";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import ButtonOutlined from "../requests/shared/helpers/ButtonOutlined";
import dayjs from "dayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { formatDateReadable } from "../requests/utilities/helpers";
import { formatPhoneNumber } from "../../../helpers/helpers";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import BarChartIcon from "@mui/icons-material/BarChart";
import LoadSpinner from "../../../utilities/LoadSpinner";

function UserProfileForEmployee(props) {
  const default_data = {
    first_name: "",
    last_name: "",
    email: "",
    phone: null,
    clock_pin: null,
    stm_id: null,
    date_of_birth: null,
    emergency_contact_name: null,
    emergency_contact_phone: null,
    emergency_contact_relationship: null,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [modalData, setModalData] = React.useState(default_data);
  const [activeTab, setActiveTab] = React.useState("Attributes");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const avatarCardColor =
    props.selectedTeamMemberData && props.roleNames
      ? getCardColor2(
          props.selectedTeamMemberData?.primary_role_id,
          props.roleNames,
          false
        )
      : "bg-slate-500";

  const avatarCardColor2 = avatarCardColor.trim();

  // Mapping for modern gradient backgrounds
  const getGradientColors = (color) => {
    const colorMap = {
      "bg-violet-600": "from-violet-50 to-violet-100",
      "bg-sky-700": "from-sky-50 to-sky-100",
      "bg-cyan-600": "from-cyan-50 to-cyan-100",
      "bg-emerald-600": "from-emerald-50 to-emerald-100",
      "bg-lime-600": "from-lime-50 to-lime-100",
      "bg-amber-500": "from-amber-50 to-amber-100",
      "bg-orange-600": "from-orange-50 to-orange-100",
      "bg-red-600": "from-red-50 to-red-100",
      "bg-pink-600": "from-pink-50 to-pink-100",
    };
    return colorMap[color] || "from-slate-50 to-slate-100";
  };

  let permissionInfo = {
    label: "",
    style: "",
  };
  if (props.selectedTeamMemberData?.permission_type === "company_admin") {
    permissionInfo = {
      label: "Admin",
      style: "border border-violet-600 bg-violet-50 text-violet-600",
    };
  } else if (
    props.selectedTeamMemberData?.permission_type === "company_manager"
  ) {
    permissionInfo = {
      label: "Manager",
      style: "border border-orange-600 bg-orange-50 text-orange-600",
    };
  } else if (
    props.selectedTeamMemberData?.permission_type === "company_timeclock"
  ) {
    permissionInfo = {
      label: "Time Clock",
      style: "border border-yellow-600 bg-yellow-50 text-yellow-700",
    };
  } else {
    permissionInfo = {
      label: "Employee",
      style: "border border-blue-600 bg-blue-50 text-blue-600",
    };
  }

  const handleDateChange = (newValue) => {
    const formattedDate = newValue ? newValue.format("YYYY-MM-DD") : "";
    setModalData((prevData) => ({
      ...prevData,
      date_of_birth: formattedDate,
    }));
  };

  function handleChange(evt) {
    const { name, value } = evt.target;
    setModalData({
      ...modalData,
      [name]: value,
    });
  }

  function handleSubmit() {
    props.post_store_team_member(
      modalData.first_name,
      modalData.last_name,
      modalData.email,
      modalData.phone,
      modalData.permission_type,
      modalData.stm_id,
      modalData.clock_pin,
      modalData.date_of_birth,
      true, // send_welcome_email
      null, // can_request_pto
      null, // can_request_sicktime
      modalData.emergency_contact_name,
      modalData.emergency_contact_phone,
      modalData.emergency_contact_relationship
    );
    handleClose();
  }

  // Code to show date picker
  const [showDailyDatePicker, setShowDailyDatePicker] = React.useState(false);
  const datePickerRef = React.useRef(null);

  function toggleDailyDatePicker() {
    setShowDailyDatePicker((prevState) => !prevState);
  }

  React.useEffect(() => {
    // This function checks if the clicked target is inside the date picker component
    function handleClickOutside(event) {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setShowDailyDatePicker(false);
      }
    }

    // Add the event listener to the document when the component is mounted
    if (showDailyDatePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up the event listener when the component is unmounted or the effect re-runs
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDailyDatePicker]);

  const tabs = [
    { id: "Attributes", label: "Attributes", icon: PersonIcon },
    { id: "Certifications", label: "Documents", icon: DescriptionIcon },
    { id: "Training", label: "Training", icon: SchoolOutlinedIcon },
    // { id: "Statistics", label: "Statistics", icon: BarChartIcon },
  ];

  // Show loading state if data is not available
  if (!props.selectedTeamMemberData) {
    return (
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <LoadSpinner />
      </div>
    );
  }

  console.log("STM", props.selectedTeamMemberData)

  return (
    <>
      <div className="bg-white shadow-sm rounded-lg overflow-hidden">
        {/* Header Section with Cover and Avatar */}
        <div className="relative">
          <div
            className={`w-full h-20 bg-gradient-to-br ${getGradientColors(avatarCardColor2)} relative`}
          >
            {/* Decorative Pattern */}
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-2 left-4 w-12 h-12 rounded-full border-2 border-white/30"></div>
              <div className="absolute top-4 right-8 w-8 h-8 rounded-full border-2 border-white/20"></div>
              <div className="absolute bottom-2 left-1/3 w-10 h-10 rounded-full border-2 border-white/25"></div>
            </div>
          </div>

          {/* Avatar */}
          <div className="absolute left-1/2 transform -translate-x-1/2 -bottom-10">
            <div
              className={`w-20 h-20 rounded-full flex items-center justify-center ${avatarCardColor} text-white text-xl font-semibold shadow-lg ring-4 ring-white`}
            >
              {props.selectedTeamMemberData &&
                getInitials(
                  props.selectedTeamMemberData?.first_name,
                  props.selectedTeamMemberData?.last_name
                )}
            </div>
          </div>
        </div>

        {/* Profile Info Section */}
        <div className="pt-12 pb-6 px-8">
          <div className="flex items-center justify-center space-x-3 mb-3">
            {/* Left spacer */}
            <div className="w-32"></div>

            {/* Name - Centered */}
            <h1 className="text-3xl font-bold text-gray-900 text-center">
              {props.selectedTeamMemberData?.first_name}{" "}
              {props.selectedTeamMemberData?.last_name}
            </h1>

            {/* Right Button Container */}
            <div className="flex items-center space-x-2 w-32">
              {/* Edit Button */}
              <div
                className="flex items-center justify-center w-8 h-8 bg-slate-100 rounded-full cursor-pointer hover:bg-slate-200 transition-colors"
                onClick={() => {
                  handleOpen();
                  setModalData({
                    first_name: props.selectedTeamMemberData?.first_name,
                    last_name: props.selectedTeamMemberData?.last_name,
                    email: props.selectedTeamMemberData?.email,
                    phone: props.selectedTeamMemberData?.phone_number,
                    clock_pin: props.selectedTeamMemberData?.clock_pin,
                    permission_type:
                      props.selectedTeamMemberData?.permission_type,
                    stm_id: props.selectedTeamMemberData?.id,
                    date_of_birth: props.selectedTeamMemberData?.date_of_birth,
                    emergency_contact_name: props.selectedTeamMemberData?.emergency_contact_name,
                    emergency_contact_phone: props.selectedTeamMemberData?.emergency_contact_phone,
                    emergency_contact_relationship: props.selectedTeamMemberData?.emergency_contact_relationship,
                  });
                }}
              >
                <Tooltip title="Edit employee info">
                  <IconButton size="small">
                    <EditIcon style={{ fontSize: "16px" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>

          <div className="text-center">
            {/* Contact Info Cards */}
            <div className="flex flex-col sm:flex-row justify-center items-center gap-2 mb-3">
              <div className="flex items-center space-x-2 bg-gray-50 px-4 py-1.5 rounded-full">
                <EmailIcon className="text-gray-500" style={{ fontSize: "18px" }} />
                <span className="text-gray-700 text-sm">
                  {props.selectedTeamMemberData?.email || "None"}
                </span>
              </div>

              <div className="flex items-center space-x-2 bg-gray-50 px-4 py-1.5 rounded-full">
                <PhoneIcon className="text-gray-500" style={{ fontSize: "18px" }} />
                <span className="text-gray-700 text-sm">
                  {props.selectedTeamMemberData?.phone_number
                    ? formatPhoneNumber(props.selectedTeamMemberData?.phone_number)
                    : "None"}
                </span>
              </div>

              {(props.clockPinEnabled ?? props.timeEntriesEnabled) && (
                <div className="flex items-center space-x-2 bg-gray-50 px-4 py-1.5 rounded-full">
                  <FiberPinIcon className="text-gray-500" style={{ fontSize: "18px" }} />
                  <span className="text-gray-700 text-sm">
                    {props.selectedTeamMemberData?.clock_pin || "None"}
                  </span>
                </div>
              )}
            </div>

            {/* Status Badges */}
            <div className="flex justify-center items-center gap-1">
              <div
                className={`${permissionInfo.style} px-3 py-1 rounded-lg flex items-center justify-center`}
              >
                <p className="text-sm">{permissionInfo.label}</p>
              </div>

              {props.selectedTeamMemberData?.is_minor && (
                <div className="bg-slate-100 border border-slate-400 text-slate-600 px-3 h-8 rounded-lg flex items-center justify-center">
                  <p className="text-sm">Minor</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="border-t border-gray-200 bg-white sticky top-0 z-10 shadow">
          <div className="flex justify-center">
            <nav className="flex space-x-8 overflow-x-auto">
              {tabs.map((tab) => {
                const IconComponent = tab.icon;
                return (
                  <button
                    key={tab.id}
                    className={`py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap transition-colors flex items-center space-x-2 ${
                      activeTab === tab.id
                        ? "border-violet-600 text-violet-700"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                    onClick={() => handleTabClick(tab.id)}
                  >
                    <IconComponent style={{ fontSize: "18px" }} />
                    <span>{tab.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white min-h-[600px] p-8">
          {activeTab === "Attributes" && (
            <UserProfileAttributesTab
              selectedTeamMemberData={props.selectedTeamMemberData}
              roleNames={props.roleNames}
              homeStore={props.homeStore}
            />
          )}

          {activeTab === "Certifications" && (
            <EmployeeProfileCertificationsTab
              certificateData={
                props.selectedTeamMemberData?.user?.certificates
              }
              post_certificate={props.post_certificate}
              delete_certificate={props.delete_certificate}
              stm_id={props.selectedTeamMemberData?.id}
              homeCompany={props.homeCompany}
              homeStore={props.homeStore}
              onRefresh={props.onRefresh}
              isSelfView={true}
            />
          )}

          {activeTab === "Training" && (
            <EmployeeProfileTrainingTab
              stm_id={props.selectedTeamMemberData?.id}
              homeCompany={props.homeCompany}
              homeStore={props.homeStore}
              certificateData={props.selectedTeamMemberData?.user?.certificates}
              onRefresh={props.onRefresh}
              isSelfView={true}
            />
          )}

          {activeTab === "Statistics" && (
            <EmployeeProfileStatisticsTab
              selectedTeamMemberData={props.selectedTeamMemberData}
            />
          )}
        </div>
      </div>

      {/* Edit Profile Drawer */}
      <Drawer anchor="right" open={open} onClose={handleClose}>
        <div className="w-[450px] h-full bg-slate-50 relative">
          <div className="max-h-screen overflow-auto">
            <DrawerHeader title={"Edit Profile Info"} onClose={handleClose} />
            <div className="px-6">
              <div className="mt-4">
                <p className="text-sm text-slate-500">First Name</p>
                <div className="mt-1">
                  <TextField
                    placeholder="John"
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="first_name"
                    value={modalData?.first_name}
                    onChange={handleChange}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "5px",
                        height: "45px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div className="mt-4">
                <p className="text-sm text-slate-500">Last Name</p>
                <div className="mt-1">
                  <TextField
                    placeholder="Smith"
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="last_name"
                    value={modalData?.last_name}
                    onChange={handleChange}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "5px",
                        height: "45px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div className="mt-4">
                <p className="text-sm text-slate-500">Email</p>
                <div className="mt-1">
                  <TextField
                    placeholder="email@email.com"
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="email"
                    value={modalData?.email}
                    onChange={handleChange}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "5px",
                        height: "45px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                      },
                    }}
                  />
                </div>
              </div>
              <div className="mt-4">
                <p className="text-sm text-slate-500">Phone</p>
                <div className="mt-1">
                  <TextField
                    placeholder="(555) 555-5555"
                    fullWidth
                    variant="outlined"
                    size="small"
                    name="phone"
                    value={modalData?.phone}
                    onChange={handleChange}
                    InputProps={{
                      sx: {
                        backgroundColor: "white",
                        borderRadius: "8px",
                        padding: "5px",
                        height: "45px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#6d28d9",
                        },
                      },
                    }}
                  />
                </div>
              </div>
              {(props.clockPinEnabled ?? props.timeEntriesEnabled) && (
                <div className="mt-4">
                  <p className="text-sm text-slate-500">Pin</p>
                  <div className="mt-1">
                    <TextField
                      placeholder="1234"
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="clock_pin"
                      value={modalData?.clock_pin}
                      onChange={handleChange}
                      InputProps={{
                        sx: {
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "5px",
                          height: "45px",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6d28d9",
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              )}
              <div className="mt-4">
                <p className="text-sm text-slate-500">Date of Birth</p>
                <div
                  className={`${
                    !showDailyDatePicker ? "border border-white" : ""
                  } flex-1 mt-1`}
                >
                  <div
                    className={`flex-1 bg-white rounded-lg text-sm ${
                      showDailyDatePicker
                        ? "border-2 border-violet-700"
                        : "border border-[#bdbdbd] hover:border-slate-900"
                    } cursor-pointer relative`}
                    ref={datePickerRef}
                  >
                    <div
                      className="w-full h-full px-3.5 py-2.5"
                      onClick={toggleDailyDatePicker}
                    >
                      <div className="w-full h-full flex items-center justify-between">
                        <p className="text-[16px]">
                          {modalData.date_of_birth
                            ? formatDateReadable(modalData.date_of_birth)
                            : "Click to select"}
                        </p>
                        <div className="text-slate-500">
                          <CalendarTodayIcon
                            style={{ fontSize: "18px", marginBottom: "2px" }}
                          />
                        </div>
                      </div>
                    </div>
                    {showDailyDatePicker && (
                      <div className="absolute bottom-12 left-0 bg-white z-10 flex items-center justify-center pl-4 pr-5 border border-[#bdbdbd] rounded-lg shadow-xl overflow-hidden">
                        <div className="mt-3">
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer
                              components={["DateCalendar", "DateCalendar"]}
                            >
                              <DemoItem>
                                <DateCalendar
                                  value={
                                    modalData?.date_of_birth
                                      ? dayjs(modalData?.date_of_birth)
                                      : null
                                  }
                                  onChange={handleDateChange}
                                  slotProps={{
                                    day: {
                                      sx: {
                                        "&.MuiPickersDay-root.Mui-selected": {
                                          backgroundColor: "#6d28d9",
                                        },
                                      },
                                    },
                                  }}
                                />
                              </DemoItem>
                            </DemoContainer>
                          </LocalizationProvider>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Emergency Contact (SB 294) */}
              <div className="mt-6">
                <p className="text-sm font-semibold text-slate-700">Emergency Contact</p>
                <div className="mt-3">
                  <p className="text-sm text-slate-500">Contact Name</p>
                  <div className="mt-1">
                    <TextField
                      placeholder="Full name"
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="emergency_contact_name"
                      value={modalData?.emergency_contact_name || ""}
                      onChange={handleChange}
                      InputProps={{
                        sx: {
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "5px",
                          height: "45px",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6d28d9",
                          },
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <p className="text-sm text-slate-500">Contact Phone</p>
                  <div className="mt-1">
                    <TextField
                      placeholder="Phone number"
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="emergency_contact_phone"
                      value={modalData?.emergency_contact_phone || ""}
                      onChange={handleChange}
                      InputProps={{
                        sx: {
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "5px",
                          height: "45px",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6d28d9",
                          },
                        },
                      }}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <p className="text-sm text-slate-500">Relationship</p>
                  <div className="mt-1">
                    <TextField
                      placeholder="e.g. Spouse, Parent, Sibling"
                      fullWidth
                      variant="outlined"
                      size="small"
                      name="emergency_contact_relationship"
                      value={modalData?.emergency_contact_relationship || ""}
                      onChange={handleChange}
                      InputProps={{
                        sx: {
                          backgroundColor: "white",
                          borderRadius: "8px",
                          padding: "5px",
                          height: "45px",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#6d28d9",
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="h-[180px]"></div>
          </div>
          <div>
            <DrawerFooterContainerLarge>
              <div className="w-full">
                <LoadingButton
                  variant="contained"
                  // loading={savingLoading}
                  loadingPosition="end"
                  endIcon={<SaveIcon />}
                  onClick={() => handleSubmit()}
                  sx={{
                    width: "100%",
                    textTransform: "none",
                    borderRadius: "12px",
                    paddingY: "14px",
                    backgroundColor: "#6d28d9",
                    "&:hover": {
                      backgroundColor: "#5b21b6",
                    },
                    fontSize: "16px",
                  }}
                >
                  Save Profile
                </LoadingButton>
              </div>
              <div className="w-full mt-3">
                <ButtonOutlined text="Cancel" onClick={() => handleClose()} />
              </div>
            </DrawerFooterContainerLarge>
          </div>
        </div>
      </Drawer>
    </>
  );
}

export default UserProfileForEmployee;
